import config from "../config";

export const fetchApps = async (token, onAuthError) => {
  try {
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${config.apiBaseUrl}/apps`, {
      headers: headers,
    });

    if (response.status === 401) {
      console.warn("Authentication error: Token invalid or expired.");
      if (onAuthError) {
        onAuthError();
      }
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching apps:", error);
    return [];
  }
};

export const fetchHelpFile = async (token) => {
  try {
    const headers = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(`${config.apiBaseUrl}/help-file`, {
      headers: headers,
    });

    if (response.status === 401) {
      console.warn("Authentication error: Token invalid or expired.");
      return [];
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.text();

    return data;
  } catch (error) {
    console.error("Error fetching apps:", error);
    return [];
  }
};
